module.exports = __webpack_public_path__ + "img/resource06.862327b9.png";